import Icon from "../../../controls/Icon";
import IconBar from "../../../controls/IconBar";
import OverlayTrigger from "../../../controls/OverlayTrigger";
import { IconButton } from "../../../controls/TooltipControls";
import { connect, PureComponentEx } from "../../../controls/ComponentEx";
import { getSafe } from "../../../util/storeHelper";
import { countIf } from "../../../util/util";
import { nexusGames } from "../../../extensions/nexus_integration/util";
import { nexusGameId } from "../../../extensions/nexus_integration/util/convertGameId";
import GameInfoPopover from "./GameInfoPopover";
import * as path from "path";
import * as React from "react";
import { Button, Panel, Popover } from "react-bootstrap";
import { Provider } from "react-redux";
import * as url from "url";
function nop() {
    // nop
}
/**
 * thumbnail + controls for a single game mode within the game picker
 *
 * @class GameThumbnail
 */
class GameThumbnail extends PureComponentEx {
    mRef = null;
    render() {
        const { t, active, discovered, game, mods, profile, type } = this.props;
        if (game === undefined) {
            return null;
        }
        let logoPath = game.extensionPath !== undefined && game.logo !== undefined
            ? path.join(game.extensionPath, game.logo)
            : game.imageURL;
        // For adaptor-registered games (no local logo), resolve a Nexus thumbnail
        if (logoPath == null) {
            const domain = nexusGameId(game);
            const numericId = domain != null
                ? nexusGames().find((g) => g.domain_name === domain)?.id
                : undefined;
            if (numericId !== undefined) {
                logoPath = `https://images.nexusmods.com/images/games/v2/${numericId}/thumbnail.jpg`;
            }
        }
        // Mod count should only be shown for Managed and Discovered games as
        //  the supported type suggests that the game has been removed from the machine.
        const modCount = profile !== undefined && type !== "undiscovered"
            ? countIf(Object.keys(profile.modState || {}), (id) => profile.modState[id].enabled && mods[id] !== undefined)
            : undefined;
        const nameParts = game.name.split("\t");
        const classes = [
            "game-thumbnail",
            `game-thumbnail-${discovered !== false ? "discovered" : "undiscovered"}`,
        ];
        let imgurl = null;
        if (logoPath != null) {
            let protocol = null;
            try {
                const parsedUrl = new URL(logoPath);
                protocol = parsedUrl.protocol;
            }
            catch (err) {
                // If URL parsing fails, treat as file path
            }
            imgurl =
                protocol !== null && protocol.startsWith("http")
                    ? logoPath
                    : url.pathToFileURL(logoPath).href;
        }
        return (React.createElement(Panel, { className: classes.join(" "), bsStyle: active ? "primary" : "default" },
            React.createElement(Panel.Body, { className: "game-thumbnail-body" },
                React.createElement("img", { className: "thumbnail-img", src: imgurl }),
                React.createElement("div", { className: "bottom" },
                    React.createElement("div", { className: "name" }, game.name),
                    modCount !== undefined ? (React.createElement("div", { className: "active-mods" },
                        React.createElement(Icon, { name: "mods" }),
                        React.createElement("span", null, t("{{ count }} active mod", { count: modCount })))) : null),
                React.createElement("div", { className: "hover-menu" }, type === "launcher" ? this.renderLaunch() : this.renderMenu()),
                type !== "launcher" ? (game.contributed ? (React.createElement("div", { className: "game-thumbnail-tags", title: game.contributed
                        ? t("Contributed by {{name}}", {
                            replace: { name: game.contributed },
                        })
                        : null }, game.contributed ? "Community" : null)) : null) : null)));
    }
    renderLaunch() {
        const { onLaunch } = this.props;
        return (React.createElement("div", { className: "hover-content hover-launcher" },
            React.createElement(Button, { style: { width: "100%", height: "100%" }, onClick: onLaunch, className: "btn-embed" },
                React.createElement(Icon, { name: "launch-application" }))));
    }
    renderMenu() {
        const { t, container, game, getBounds, onRefreshGameInfo, type } = this.props;
        const gameInfoPopover = (React.createElement(Popover, { id: `popover-info-${game.id}`, className: "popover-game-info" },
            React.createElement(Provider, { store: this.context.api.store },
                React.createElement(IconBar, { id: `game-thumbnail-${game.id}`, className: "buttons", group: `game-${type}-buttons`, instanceId: game.id, staticElements: [], collapse: false, buttonType: "text", orientation: "vertical", filter: this.lowPriorityButtons, t: t }),
                React.createElement(GameInfoPopover, { t: t, game: game, onRefreshGameInfo: onRefreshGameInfo, onChange: this.redraw }))));
        return [
            React.createElement("div", { key: "primary-buttons", className: "hover-content" },
                React.createElement(IconBar, { id: `game-thumbnail-${game.id}`, className: "buttons", group: `game-${type}-buttons`, instanceId: game.id, staticElements: [], collapse: false, buttonType: "text", orientation: "vertical", filter: this.priorityButtons, clickAnywhere: true, t: t })),
            React.createElement(OverlayTrigger, { key: "info-overlay", overlay: gameInfoPopover, triggerRef: this.setRef, getBounds: getBounds || this.getWindowBounds, container: container, orientation: "horizontal", shouldUpdatePosition: true, trigger: "click", rootClose: true },
                React.createElement(IconButton, { id: `btn-info-${game.id}`, icon: "game-menu", className: "game-thumbnail-info btn-embed", tooltip: t("Show Details") })),
        ];
    }
    priorityButtons = (action) => action.position < 100;
    lowPriorityButtons = (action) => action.position >= 100;
    getWindowBounds = () => {
        return {
            top: 0,
            left: 0,
            height: window.innerHeight,
            width: window.innerWidth,
            bottom: window.innerHeight,
            right: window.innerWidth,
        };
    };
    setRef = (ref) => {
        this.mRef = ref;
    };
    redraw = () => {
        if (this.mRef !== null) {
            this.mRef.forceUpdate();
        }
    };
}
const emptyObj = {};
function mapStateToProps(state, ownProps) {
    const profiles = state.persistent.profiles;
    const lastActiveProfile = ownProps.game !== undefined
        ? getSafe(state.settings.profiles, ["lastActiveProfile", ownProps.game.id], undefined)
        : undefined;
    const profile = lastActiveProfile !== undefined ? profiles[lastActiveProfile] : undefined;
    return {
        profile,
        mods: (profile !== undefined
            ? state.persistent.mods[profile.gameId]
            : emptyObj) || emptyObj,
    };
}
export default connect(mapStateToProps)(GameThumbnail);
